import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Cloud_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.13184 5.41703C4.69203 4.12444 5.97497 3.25 7.41456 3.25H8.10257C10.0447 3.25 11.662 4.64081 12.0128 6.48077H12.1154C13.5704 6.48077 14.75 7.66033 14.75 9.11539C14.75 10.5704 13.5704 11.75 12.1154 11.75H4.42308C2.67064 11.75 1.25 10.3294 1.25 8.57692C1.25 6.92267 2.51591 5.56408 4.13184 5.41703ZM10.5833 7.23077C10.5833 5.86068 9.47266 4.75 8.10257 4.75H7.41456C6.51137 4.75 5.69949 5.35353 5.42916 6.2269C5.30645 6.62336 4.93839 6.90385 4.51231 6.90385H4.42308C3.49906 6.90385 2.75 7.65291 2.75 8.57692C2.75 9.50094 3.49906 10.25 4.42308 10.25H12.1154C12.742 10.25 13.25 9.74202 13.25 9.11539C13.25 8.48875 12.742 7.98077 12.1154 7.98077H11.3333C10.9191 7.98077 10.5833 7.64498 10.5833 7.23077Z"
            />
        </SvgStyled>
    );
};

export default Cloud_xs;
